import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';

export type NotificationType = 'email' | 'sms';

export interface NotificationProviderConfig {
  host?: string;
  port?: number;
  secure?: boolean;
  user?: string;
  pass?: string;
  fromEmail?: string;
  fromName?: string;
  [key: string]: unknown;
}

export interface NotificationProvider {
  id: string;
  tenantId: string | null;
  notificationType: NotificationType;
  providerSlug: string;
  config: NotificationProviderConfig;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationProviderListResult {
  notificationProviders: NotificationProvider[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface NotificationProviderPayload {
  notificationType?: NotificationType;
  providerSlug: string;
  config: NotificationProviderConfig;
  isActive?: boolean;
}

export const notificationProviderService = {
  async list(): Promise<NotificationProviderListResult> {
    return apiClient.get<NotificationProviderListResult>(API_ENDPOINTS.NOTIFICATION_PROVIDERS.LIST, {
      authenticate: true,
    });
  },

  async create(payload: NotificationProviderPayload): Promise<NotificationProvider> {
    return apiClient.post<NotificationProvider>(API_ENDPOINTS.NOTIFICATION_PROVIDERS.CREATE, payload, {
      authenticate: true,
    });
  },

  async update(id: string, payload: Partial<NotificationProviderPayload>): Promise<NotificationProvider> {
    return apiClient.patch<NotificationProvider>(API_ENDPOINTS.NOTIFICATION_PROVIDERS.UPDATE(id), payload, {
      authenticate: true,
    });
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.NOTIFICATION_PROVIDERS.DELETE(id), { authenticate: true });
  },
};
